import type { MockApiRequestHandler } from "@kalmarenergi/util/interceptors/mock-api";

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseApi: "https://ke-apim-dev.azure-api.net/",
  mockApi: {
    enabled: false,
    handlers: [] as MockApiRequestHandler[],
  },
};
